import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "modal-target" }, null, -1)
const _hoisted_3 = { class: "appView" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_site_header = _resolveComponent("site-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_error_display = _resolveComponent("error-display")!
  const _component_site_footer = _resolveComponent("site-footer")!
  const _component_cookie_popup = _resolveComponent("cookie-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_site_header),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.showError)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : (_openBlock(), _createBlock(_component_error_display, { key: 1 }))
    ]),
    _createVNode(_component_site_footer),
    _createVNode(_component_cookie_popup)
  ]))
}